import { InjectionToken } from '@angular/core';
import { ISbComponentType } from 'storyblok-js-client';
import { IDisplayStyle, ISpacingStyle } from '@seven1/model';

export type TrustpilotLanguage = 'de' | 'en';

export interface ITrustpilotBlock extends ISbComponentType<'trustpilot'>, ISpacingStyle, IDisplayStyle {
    componentId?: string;
    variant: 'mini' | 'horizontal' | 'slider' | 'carousel';
    language?: TrustpilotLanguage;
    reviewLanguage?: TrustpilotLanguage;
    showReviewExplainer?: boolean;
}

export const TRUSTPILOT_TRANSLATIONS: Record<TrustpilotLanguage, {
    excellent: string;
    great: string;
    average: string;
    poor: string;
    bad: string;
    reviews: string;
    verified: string;
    trustScore: string;
    outOf5BasedOn: string;
    rated: string;
    showingLatestReviews: string;
    checksReviews: string;
    previousReviews: string;
    nextReviews: string;
    basedOn: string;
}> = {
    de: {
        excellent: 'Hervorragend',
        great: 'Gut',
        average: 'Befriedigend',
        poor: 'Mangelhaft',
        bad: 'Ungenügend',
        reviews: 'Bewertungen',
        verified: 'Verifiziert',
        trustScore: 'TrustScore',
        outOf5BasedOn: 'von 5 basierend auf',
        rated: 'Bewertet',
        showingLatestReviews: 'Unsere neuesten Bewertungen.',
        checksReviews: 'Trustpilot überprüft Bewertungen',
        previousReviews: 'Vorherige Bewertungen',
        nextReviews: 'Nächste Bewertungen',
        basedOn: 'Basierend auf',
    },
    en: {
        excellent: 'Excellent',
        great: 'Great',
        average: 'Average',
        poor: 'Poor',
        bad: 'Bad',
        reviews: 'reviews',
        verified: 'Verified',
        trustScore: 'TrustScore',
        outOf5BasedOn: 'out of 5 based on',
        rated: 'Rated',
        showingLatestReviews: 'Showing our latest reviews.',
        checksReviews: 'Trustpilot checks reviews',
        previousReviews: 'Previous reviews',
        nextReviews: 'Next reviews',
        basedOn: 'Based on',
    },
};

export type TrustpilotReview = {
    id: string;
    stars: number;
    title: string;
    text: string;
    consumer: string;
    createdAt: string;
    isVerified: boolean;
};

export type TrustpilotData = {
    score: {
        trustScore: number;
        stars: number;
    };
    numberOfReviews: number;
    profileUrl: string;
    reviews: Record<TrustpilotLanguage, TrustpilotReview[]>;
    lastUpdatedAt: string;
};

export const TRUSTPILOT_SERVER_DATA = new InjectionToken<TrustpilotData>('TRUSTPILOT_SERVER_DATA');
